//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    NOTES_GET_NOTE_REQUEST,
    NOTES_CREATE_REQUEST,
    NOTES_UPDATE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    notesCreateResult,
    notesGetNoteResult,
    notesUpdateResult,
} from 'Redux/actions';

function* getNote({ payload }) {
    try {
        let { id, show } = payload;
        let result = null;
        if (id) {
            let QUERY = `
            query getEntityNote ($id: Int!) {
                result: getEntityNote (id: $id) {
                    id
                    projectId
                    entity
                    note
                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

            let data = yield call(
                clientQuery,
                QUERY,
                {
                    id: id
                },
                endpoints.GRAPHQL_GENERAL,
            );

            result = data.result;
            if (result) {
                result = JSON.parse(JSON.stringify(result));
                result.show = show;
            }
        }
        yield put(notesGetNoteResult(result))

    } catch (exc) {
        yield put(notesGetNoteResult())
        ExceptionManager(exc, 'Modules/devices/.components/createEditNote/notesTab/.components/redux/saga', 'getNote');
    }
}

function* createNote({ payload }) {
    try {
        let QUERY = `
            mutation createEntityNote ($projectId: enumProjectId!, $entityName: enumEntityName, $entityId: String!, $note: String!) {
               result: createEntityNote (projectId: $projectId, entityName: $entityName, entityId: $entityId, note: $note) {
                    id
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(notesCreateResult(data?.result))
        } else yield put(notesCreateResult())

    } catch (exc) {
        yield put(notesCreateResult({ error: exc }))
        ExceptionManager(exc, 'Modules/devices/.components/createEditNote/notesTab/.components/redux/saga', 'createNote');
    }
}

function* updateNote({ payload }) {
    try {
        let QUERY = `
            mutation updateEntityNote ($id: Int!, $note: String!) {
                result: updateEntityNote (id: $id, note: $note) {
                    id
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(notesUpdateResult(data?.result));

    } catch (exc) {
        yield put(notesUpdateResult({ error: exc }));
        ExceptionManager(exc, 'Modules/devices/.components/createEditNote/notesTab/.components/redux/saga', 'updateNote');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(NOTES_GET_NOTE_REQUEST, getNote);
    yield takeEvery(NOTES_CREATE_REQUEST, createNote);
    yield takeEvery(NOTES_UPDATE_REQUEST, updateNote);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}